import lazyLoading from "./lazyLoading";

export default {
  name: "uputnice",
  path: "/uputnice",
  component: lazyLoading("02_uputnice/PregledUputnica"),
  meta: {
    default: false,
    title: "Uputnice",
    class: "primary",
    show: false,
    iconClass: "fa fa-users",
    requiredAuth: true
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/uputnice.js